import { render, staticRenderFns } from "./AppCompanyIconMenuGroup.vue?vue&type=template&id=ae0039d0&scoped=true&"
import script from "./AppCompanyIconMenuGroup.vue?vue&type=script&lang=js&"
export * from "./AppCompanyIconMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppCompanyIconMenuGroup.vue?vue&type=style&index=0&id=ae0039d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0039d0",
  null
  
)

export default component.exports